import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Custom.
import { VoDocs } from "@vocollege/app";
import { VoApi } from "@vocollege/app";
import "@vocollege/app";
import Layout from "containers/Layout/Layout";
import {
  GET_PORTFOLIOS,
  GET_FOLDER_ELEMENTS,
  CREATE_PORTFOLIO,
  UPDATE_PORTFOLIO,
  DELETE_PORTFOLIO,
  CREATE_FOLDER,
  UPDATE_FOLDER,
  DELETE_FOLDER,
  CREATE_FILE,
  UPDATE_FILE,
  DELETE_FILE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import FileManager from "@vocollege/components/dist/FileManager";
import VoLoader from "@vocollege/components/dist/VoLoader";

export default function Docs() {
  const [loading, setLoading] = useState(true);
  const [portfolioId, setPortfolioId] = useState<null | string>(null);
  const [folderId, setFolderId] = useState<null | string>(null);
  const [operation, setOperation] = useState(GET_PORTFOLIOS);
  const [category, setCategory] = useState("portfolios");
  const params = useParams<any>();

  // This is required if uploading through Laravel
  useEffect(() => {
    VoDocs.init();
  }, []);

  useEffect(() => {
    setLoading(true);
    setPortfolioId(params.portfolioId || null);
    setFolderId(params.folderId || null);
    if (params.portfolioId || params.folderId) {
      setOperation(GET_FOLDER_ELEMENTS);
      setCategory("folderElements");
    } else {
      setOperation(GET_PORTFOLIOS);
      setCategory("portfolios");
    }
    setLoading(false);
  }, [params]);

  return (
    <Layout>
      {loading && <VoLoader />}
      {!loading && (
        <FileManager
          classes={{}}
          portfolioId={portfolioId}
          baseUrl="/docs"
          folderId={folderId}
          client={VoApi.graphqlClient} // This is required if uploading through Laravel
          operations={{
            category: category,
            get: operation,
            createPortfolio: CREATE_PORTFOLIO,
            updatePortfolio: UPDATE_PORTFOLIO,
            deletePortfolio: DELETE_PORTFOLIO,
            createFolder: CREATE_FOLDER,
            updateFolder: UPDATE_FOLDER,
            deleteFolder: DELETE_FOLDER,
            createFile: CREATE_FILE,
            updateFile: UPDATE_FILE,
            deleteFile: DELETE_FILE,
          }}
        />
      )}
    </Layout>
  );
}
